// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"f2b1c681","77":"c2653afc","796":"f7a80350","815":"c53dc3cd","828":"e0313e59"}[chunkId] + ".chunk.js";
};